module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/icon//icon-back.png?v=dd5cb413";